import { useState, useEffect } from 'react';
import * as moment from 'moment';
import { IWatrRequest } from '@nkr/models/index';
import { FormControl, Button, Well, InputGroup, ControlLabel, Modal, FormGroup, HelpBlock } from 'react-bootstrap';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    data: IWatrRequest,
    onConfirmDonation: (requestId: number, signOffInitials: string, confirmDonation: boolean) => void,
    onUpdateDonationDate: (requestId: number, donationDate: string) => void,
    onClose: () => void
}

const ConfirmDonation = (props: IProps) => {
    const [donationDate, setDonationDate] = useState('');
    const [donationDateError, setDonationDateError] = useState(false);
    const [signOffInitials, setSignOffInitials] = useState('');
    const [initialsError, setInitialsError] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            let date = moment(props.data.donationDate).isValid()
                ? moment(props.data.donationDate).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');

            setDonationDate(date); ''
            setDonationDateError(false);

            setSignOffInitials('');
            setInitialsError(false);
        }
    }, [props.show]);

    const handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'donationDate') {
            setDonationDate(value);
        }

        if (name == 'signOffInitials') {
            setSignOffInitials(value);
        }
    };

    const handleConfirmDonation = () => {
        if (signOffInitials != '') {
            props.onConfirmDonation(props.data.id, signOffInitials, true);
        } else {
            setInitialsError(true);
        }
    };

    const handleUpdateDonationDate = () => {
        if (moment(donationDate).isValid()) {
            props.onUpdateDonationDate(props.data.id, donationDate);
        } else {
            setDonationDateError(true);
        }
    }

    if (props.data == null)
        return null;

    const predefinedDate = moment(props.data.donationDate).isValid() ? moment(props.data.donationDate).format('MM/DD/YYYY') : '';
    const disableConfirmDonation = predefinedDate == '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Donation for <strong>{props.data.firstName + ' ' + props.data.lastName}</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20 }}>
                    <h4 style={{ margin: 0 }}>
                        Current Status: <span className='label label-info'>{props.data.statusDescription}</span>
                    </h4>
                </div>

                <Well bsSize='sm'>
                    <FormGroup style={{ marginBottom: 0 }} validationState={donationDateError ? 'error' : null}>
                        <ControlLabel>Update Donation Date:</ControlLabel>
                        <InputGroup>
                            <FormControl
                                type='date'
                                id='donationDate'
                                name='donationDate'
                                value={donationDate}
                                onChange={handleInputChange}
                            />
                            <InputGroup.Button>
                                <Button bsStyle='primary' onClick={handleUpdateDonationDate}>Update</Button>
                            </InputGroup.Button>
                        </InputGroup>

                        {donationDateError && (
                            <HelpBlock>Please enter a valid date to continue...</HelpBlock>
                        )}
                    </FormGroup>
                </Well>

                <div>
                    {disableConfirmDonation ?
                        <div style={{ textAlign: 'center' }}>
                            <ControlLabel>Donation Date Required for Confirmation</ControlLabel>
                        </div>
                        :
                        <>
                            <div style={{ textAlign: 'center', marginBottom: 20 }}>
                                <ControlLabel>Or, Confirm Donation</ControlLabel>
                            </div>

                            <Well bsSize='sm'>
                                <FormGroup style={{ marginBottom: 0 }} validationState={initialsError ? 'error' : null}>
                                    <ControlLabel>Please confirm there is a medical reason the donor cannot work in their field/career...</ControlLabel>

                                    <InputGroup>
                                        <FormControl
                                            id='initials'
                                            name='signOffInitials'
                                            placeholder='Your Initials'
                                            maxLength={3}
                                            value={signOffInitials}
                                            onChange={handleInputChange}
                                        />
                                        <InputGroup.Button>
                                            <Button bsStyle='primary' disabled={disableConfirmDonation} onClick={handleConfirmDonation}>
                                                Confirm Donated on {predefinedDate}
                                            </Button>
                                        </InputGroup.Button>
                                    </InputGroup>

                                    {initialsError && (
                                        <HelpBlock>You must enter your initials to continue...</HelpBlock>
                                    )}
                                </FormGroup>
                            </Well>
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDonation;